import { useNavigate, useParams } from "react-router-dom"
import { useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import PasswordChecklist from "./PasswordChecklist"
import { passwordOk } from "../util/passwordRules"

const ResetPassword = () => {
  const navigate = useNavigate()
  const { ev_str: token } = useParams()

  const [password, setPassword] = useState("")
  const [confirm, setConfirm] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!passwordOk(password))
      return toast.error("Your new password doesn't meet all the requirements yet", { position: "bottom-left" })
    if (password !== confirm)
      return toast.error("Passwords do not match", { position: "bottom-left" })

    try {
      setLoading(true)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password }),
      })
      const data = await res.json()
      if (!res.ok || !data.success) throw new Error(data.message || "Reset failed")

      toast.success("Password updated — you can log in now", { position: "bottom-right" })
      setTimeout(() => navigate("/login"), 1200)
    } catch (err) {
      toast.error(err.message, { position: "bottom-left" })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="Login justify-content-center d-flex h-100 align-items-center">
      <div className="row col-xl-6 col-md-8 col-11 py-5 mx-2">
        <form onSubmit={handleSubmit} className="p-4 p-md-5 border rounded-3 bg-light text-start" noValidate>
          <h1 className="display-4 mb-4 text-center">Reset Password</h1>

          <div className="form-floating mb-2">
            <input
              id="new-password"
              type="password"
              className="form-control"
              placeholder="New password"
              autoComplete="new-password"
              aria-describedby="password-rules"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label htmlFor="new-password">New password</label>
          </div>
          <PasswordChecklist id="password-rules" password={password} />

          <div className="form-floating mb-3">
            <input
              id="confirm-password"
              type="password"
              className="form-control"
              placeholder="Confirm password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
            <label htmlFor="confirm-password">Confirm new password</label>
          </div>

          <button className="w-100 btn btn-lg btn-primary" type="submit" disabled={loading}>
            {loading ? "Updating…" : "Update Password"}
          </button>
        </form>
        <ToastContainer />
      </div>
    </div>
  )
}

export default ResetPassword
